// Shared admin panel/utility components — DRY across admin pages.
import { ShieldStar } from "@phosphor-icons/react";

export function Panel({ title, tag, children, className = "", testid }) {
  return (
    <div className={`border border-zinc-800 bg-bg-surface grain ${className}`} data-testid={testid}>
      <div className="flex items-center justify-between px-5 py-3 border-b border-zinc-900">
        <span className="text-[10px] tracking-[0.3em] uppercase text-ink-dim flex items-center gap-2">
          <ShieldStar size={11} weight="bold" className="text-brand-red" /> {title}
        </span>
        {tag && <span className="text-[9px] tracking-[0.3em] uppercase text-brand-red animate-flicker">● {tag}</span>}
      </div>
      <div className="p-5">{children}</div>
    </div>
  );
}

export function AdminHeader({ section, title, accent = "text-brand-red", right }) {
  return (
    <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
      <div>
        <div className="text-[10px] tracking-[0.4em] uppercase text-brand-red mb-2">◢ {section}</div>
        <h1 className="font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl leading-[0.9]">
          {title.map((t, i) =>
            t.startsWith("*") ? <span key={i} className={`${accent} neon-red`}>{t.slice(1)}</span> : <span key={i}>{t}</span>
          )}
        </h1>
      </div>
      {right}
    </div>
  );
}

export function Stat({ label, value, Icon, color = "text-brand-red", testid }) {
  return (
    <div className="bg-bg-surface p-5" data-testid={testid}>
      <div className="flex items-center justify-between mb-3">
        <span className="text-[9px] tracking-[0.3em] uppercase text-ink-dim">{label}</span>
        {Icon && <Icon size={14} weight="bold" className={color} />}
      </div>
      <div className="font-display font-black text-3xl tracking-tighter">{value}</div>
    </div>
  );
}

export function Field({ label, value, onChange, type = "text", placeholder, testid, multiline = false, ...rest }) {
  const Cmp = multiline ? "textarea" : "input";
  return (
    <label className="block">
      <span className="text-[9px] tracking-[0.3em] uppercase text-ink-dim">{label}</span>
      <Cmp
        type={multiline ? undefined : type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testid}
        rows={multiline ? 3 : undefined}
        {...rest}
        className="mt-1 w-full bg-black border border-zinc-800 px-2 py-1.5 text-sm font-mono outline-none focus:border-brand-red resize-none"
      />
    </label>
  );
}

export function SelectField({ label, value, onChange, options, testid }) {
  return (
    <label className="block">
      <span className="text-[9px] tracking-[0.3em] uppercase text-ink-dim">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="mt-1 w-full bg-black border border-zinc-800 px-2 py-1.5 text-sm font-mono outline-none focus:border-brand-red appearance-none"
      >
        {options.map((o) => (
          <option
            key={typeof o === "string" ? o : o.value}
            value={typeof o === "string" ? o : o.value}
            label={typeof o === "string" ? o.toUpperCase() : o.label}
          />
        ))}
      </select>
    </label>
  );
}
